
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { Router } from "@angular/router";
import { MemberService } from '../shared/services/member.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.css']
})
export class HelpdeskComponent implements OnInit {
  displayedColumns: string[] = ['ticketId','User Type','Category/Sub Category','subject','Status' ,'assignedFrom','assignedTo','createdDate','action','comments'];
  dataSource: MatTableDataSource<any>;
  selectedType: Number=0;
  token: string;
  roleList: any;
  length:Number;
  pageNo:number=0;
  PageSize:Number=10;
  searchKey: any = '';
  roleTypes = [];
  color:string;
  helpDeskList :any[]=[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isPresent: boolean;
  selectedSubCategory: number;
  subCatagoryDropDown: any;
  filteredHelpDeskList: any[];
  selectedCategory: any;
  supportList: any;
  Filter: any;
  subCatagoryDropDowns: any;
  catagoryDropDown: any;
  dropDown = [
    { id: 1, value: 'Yet To Assign' },
    { id: 2, value: 'Active' },
    { id: 3, value: 'Completed' },
    {id:4,value:'On Hold'},
    {id:5,value:'Cancelled'},
    {id:6,value:'Assigned'}
  ];
  selectedAssigner: string = 'Select Status';
  enableName: string='View More';
  enable: boolean;
  ticketId: any;
  GenraralFilter: any;
  selectedAssigners:any;

  constructor(private cdr: ChangeDetectorRef,private spinnerService: NgxSpinnerService, private memberService: MemberService, private formBuilder: FormBuilder, private router: Router) {
  }
  ngOnInit(): void {
    this.selectedAssigner= 'Select Status';
    let user = JSON.parse(localStorage.getItem("currentUser"));
    this.token = "Bearer" + " " + user.jwtToken;
    // this.dataSource.paginator = this.paginator;
    this.dataSource = new MatTableDataSource(this.helpDeskList);
    this.getRoles();
    this.getSupportList();
    // this.catagoryDropDown();
    this.getCatogoryList();
    this.getHelpdesk(this.pageNo+1,this.PageSize,this.searchKey,this.selectedType,0,0);
    
  }
  enablefilter(value){
    // this.enable=false;
    if(!value){
      this.enableName='View Less ';
      this.enable=true;
    }
    else{
      this.enableName='View More ';
      this.enable=false;
    }
    
    
   
  }
  Submit() {
         console.log('Submit',this.selectedAssigner);
         let params={
           "categoryId":this.selectedAssigners,
           "ticketId":this.ticketId
         }
         this.spinnerService.show();
         console.log(params);
         this.memberService.PostAdminGeneralTicketTransfer(params,this.token).subscribe(
           (data: any) => {
             // this.ishubspotLoading = false;
             if (data.statusCode == 200|| data.statusCode==204) {
               $("#AssignSupport").modal("hide");
               Swal.fire({
                 title: data.statusMessage,
                 icon: "success",
                 showCloseButton: true,
                 allowOutsideClick: false
               });
               this.spinnerService.hide();
               this.ngOnInit();
             }
             else {
              
               Swal.fire({
                 title: data.statusMessage,
                 icon: "warning",
                 showCloseButton: true,
                 allowOutsideClick: false
               });
               this.spinnerService.hide();
     
             }
           },
           err => {
             if (err.status === 401) {
               this.spinnerService.hide();
               this.unauthorizedException();
             }
           }
         );
         
         // Your submit logic here
       }
  getCatogoryList(){
    this.spinnerService.show();

    // this.catagoryDropDown = [
    //   {
    //     categoryId: 77,
    //     categoryName: "General",
    //     subCategoryList: []
    //   },
    //   {
    //     categoryId: 73,
    //     categoryName: "IT Admin",
    //     subCategoryList: []
    //   },
    //   {
    //     categoryId: 71,
    //     categoryName: "Emergency Team",
    //     subCategoryList: [
    //       {
    //         categoryId: 72,
    //         categoryName: "HR",
    //         parentCategoryId: 71
    //       }
    //     ]
    //   },
    //   {
    //     categoryId: 8,
    //     categoryName: "Tribal Council",
    //     subCategoryList: [
    //       {
    //         categoryId: 66,
    //         categoryName: "Emergency IT",
    //         parentCategoryId: 8
    //       },
    //       {
    //         categoryId: 67,
    //         categoryName: "Emergency Industry",
    //         parentCategoryId: 8
    //       }
    //     ]
    //   },
    //   {
    //     categoryId: 5,
    //     categoryName: "Tribal Member",
    //     subCategoryList: [
    //       {
    //         categoryId: 55,
    //         categoryName: "Help Desk",
    //         parentCategoryId: 5
    //       },
    //       {
    //         categoryId: 57,
    //         categoryName: "IT",
    //         parentCategoryId: 5
    //       },
    //       {
    //         categoryId: 64,
    //         categoryName: "HR",
    //         parentCategoryId: 5
    //       }
    //     ]
    //   }
    // ];
    
  
  
    // this.catagoryDropDown.map(value=>({
    //   categoryName:value.categoryName,
    //   categoryId:parseInt(value.categoryId),
    // })
    // );
    //   this.subCatagoryDropDowns = this.catagoryDropDown
    //       .map(value => value.subCategoryList) // Extract subCategoryList arrays
    //       .flat() // Flatten the array of arrays into a single array
    //       .map(value => ({
    //         categoryName: value.categoryName,
    //         categoryId: parseInt(value.categoryId),
    //         parentCategoryId: parseInt(value.parentCategoryId)
    //       })); 
          console.log(this.subCatagoryDropDowns);
    this.memberService
    .getCatogoryList( this.token)
    .subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.catagoryDropDown=data.categoryLists;
          this.catagoryDropDown=this.catagoryDropDown.map(value=>({
            categoryName:value.categoryName,
            categoryId:parseInt(value.categoryId),
          })
          );
          this.GenraralFilter=this.catagoryDropDown.filter((value=>value.categoryName!='General'));
        
          this.subCatagoryDropDowns = data.categoryLists.map((value=>value.subCategoryList));
          
          this.subCatagoryDropDowns = data.categoryLists
          .map(value => value.subCategoryList) // Extract subCategoryList arrays
          .flat() // Flatten the array of arrays into a single array
          .map(value => ({
            categoryName: value.categoryName,
            categoryId: parseInt(value.categoryId),
            parentCategoryId: parseInt(value.parentCategoryId)
          })); 
          
        
        console.log('usb',this.subCatagoryDropDowns)

          // this.groupList= data.vendorGroupList.map(group => ({
          //   id: group.groupId,
          //   name: group.name,
          // }));
         console.log('data -------> ',this.catagoryDropDown);
          return;
        }
      },
      err => {
        if (err.status === 401) {
          this.unauthorizedException();
        }
      }
    );
  }
  hide(){
    $("#AssignSupport").modal("hide");
  }
   getSupportList(){
         this.memberService.SupportHelpdeskList(this.token).subscribe(
               (data: any) => {
                 // this.ishubspotLoading = false;
                 if (data.statusCode == 200) {
                   this.Filter=data.supportList;
                   this.supportList = data.supportList.filter((value=> value.isActive === true && value.parentCategoryId !=0 )).map(value => ({
                     id: value.supportId,
                     firstName: value.firstName+" "+value.lastName,
                     typeOfMember:value.typeOfMember,
                     parentCategoryName:value.parentCategoryName,
                     subCategoryName:value.subCategoryName
                   }));
                   this.supportList.forEach(role => {
                    role.displayName = `${role.firstName} - ${role.parentCategoryName || 'N/A'} - ${role.typeOfMember}`;
                  });
                  
                   this.spinnerService.hide();
                 }
                 else {
                  
                   Swal.fire({
                     title: data.statusMessage,
                     icon: "warning",
                     showCloseButton: true,
                     allowOutsideClick: false
                   });
                   this.spinnerService.hide();
         
                 }
               },
               err => {
                 if (err.status === 401) {
                   this.spinnerService.hide();
                   this.unauthorizedException();
                 }
               }
             );
       
       }
  editcategory(row){
    this.ticketId=row.ticketId;

    $("#AssignSupport").modal("show");

  }
  oncatogorySelect(selectedValue: any): void {
    // if(selectedValue==0){
    //   this.onclick=false;
    // }
    // this.onclick=true;
    // Reset the subcategory list and presence flag
    this.isPresent = false;
    this.selectedSubCategory=0;
    console.log('Selected Value:', selectedValue);
    console.log('Original Subcategory List:', this.subCatagoryDropDowns);
  
    // Filter the subcategories based on the selected parent category ID
    this.subCatagoryDropDown = this.subCatagoryDropDowns.filter(
      (x) => x.parentCategoryId == selectedValue
    );
    
  
    console.log('Filtered Subcategory List:', this.subCatagoryDropDown);
    console.log('Selected Value ',this.helpDeskList);
    // console.log('Suu[',this.Filter);
   
    // Update the presence flag based on the filtered list
    this.isPresent = this.subCatagoryDropDown.length > 0;
    // this.filteredHelpDeskList = this.helpDeskList.filter((value)=>parseInt(value.parentCategoryId)==parseInt(selectedValue) );
    // this.filteredHelpDeskList = this.helpDeskList.filter((item) => {
    //   // Match parent category if a parent category is selected
    //   const matchesParent = this.selectedCategory
    //     ? item.parentCategoryId === this.selectedCategory
    //     : true;
    
      
    //   // Return only items that match both filters
    //   return matchesParent
    // });

    
  console.log('Fiters',this.filteredHelpDeskList);
  if(!this.isPresent){
    // this.supportList=this.Filter.filter(value=>value.parentCategoryId==this.selectedCategory );
    // // Update the MatTableDataSource with filtered data
    // this.dataSource = new MatTableDataSource(this.filteredHelpDeskList);
    
    // this.length=this.filteredHelpDeskList.length;
    this.paginator.pageIndex=0;
    this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);

  }
  }
  getStatusColor(status: string | null | undefined): string {
    switch (status) {
      case 'Active':
        return '#fff3cd'; // Custom green
      case 'Completed':
        return '#d4edda'; // Custom yellow
      case 'Cancelled':
        return '#f8d7da';
      case 'On Hold':
       return '#a9a9a9';
       case 'Assigned':
      return '#d1ecf1';
      case 'Yet To Assign':
      return '#f8c8b1 ';
    // Custom red
      default:
        return '#f8c8b1'; // Default gray
    }
  }
  getTextColor(status: string | null | undefined): string {
    switch (status) {
      case 'Active':
        return '#856404'; // Darker yellow (Amber)
      case 'Completed':
        return '#218838'; // Darker green
      case 'Cancelled':
        return 'red'; // Darker red
      case 'On Hold':
        return '#495057'; // Darker gray
      case 'Assigned':
        return '#0c5460'; // Darker blue
      case 'Yet To Assign':
        return '#b3540f'; // Darker orange
      default:
        return '#b3540f'; // Default dark gray
    }
  }
  // subCatagoryDropDowns(arg0: string, subCatagoryDropDowns: any) {
  //   throw new Error('Method not implemented.');
  // }
onSubcatogorySelect(selectedValue: any): void {
// this.supportList = this.Filter
// .filter(value => 
//   value.typeOfMember !== "Assigner" && 
//   value.isActive === true && 
//   value.parentCategoryId === this.selectedCategory && 
//   value.subCategoryId === this.selectedSubCategory
// )
// .map(value => ({
//   id: value.supportId,
//   firstName: `${value.firstName} ${value.lastName}`
// }));
//     this.filteredHelpDeskList = this.helpDeskList.filter((item) => {
//       // Match parent category if a parent category is selected
//       const matchesParent = this.selectedCategory
//         ? item.parentCategoryId === this.selectedCategory
//         : true;
    
//         const matchesSub = this.selectedSubCategory
//         ? item.subCategoryId === this.selectedSubCategory
//         : true;
//       // Return only items that match both filters
//       return matchesParent  && matchesSub;
//     });
    this.paginator.pageIndex=0;
    this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);

    // this.dataSource = new MatTableDataSource(this.filteredHelpDeskList);
    // this.length=this.filteredHelpDeskList.length;
  }
  getRoles() {
  // console.log('jnjnn');
   this.memberService
      .getRoleValues(this.token)
      .subscribe(
        (data:any) => {
          console.log('data',data)
          this.roleList = data;
          this.roleTypes = this.roleList.roleType
          console.log('role',this.roleTypes);
          this.paginator.pageIndex=0;
          this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
        },
        err => {
          if (err.status === 401) {
            this.unauthorizedException();
            this.spinnerService.hide();
          }
        }
      );
  }
  onSelectChanges(event: any): void {
    this.pageNo=0;
    this.paginator.pageIndex=0;
    this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
  }

  getHelpdesk(pageNo, pageSize, searchKey, roleType,parentcategoryId,subcategoryId) {
    let params = {
      "search": searchKey.trim(),
      "userTypeId": roleType,
      "pageNo": pageNo,
      "pageSize": pageSize,
      "parentCategoryId":parentcategoryId,
      "subCategoryId":subcategoryId,
      "status":this.selectedAssigner=='Select Status'?'':this.selectedAssigner,
      "adminUser": true,

    };
    this.spinnerService.show();
    // Assign the data to the data source for the table to render
    this.memberService.getHelpDesk(params, this.token).subscribe(
      (data: any) => {
        // this.ishubspotLoading = false;
        if (data.statusCode == 200) {
          console.log(data.statusCode)
          console.log(data);
          this.length=data.filteredCount;
          this.helpDeskList=data.helpDeskList;
          // this.selectedAssigner="";
          // this.selectedCategory=0;
          // this.selectedSubCategory=0;
          this.dataSource = new MatTableDataSource(this.helpDeskList);
          this.spinnerService.hide();
        }
        else {
        
          // this.isLoading = false;
          Swal.fire({
            title: data.statusMessage,
            icon: "warning",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();

        }
      },
      err => {
        if (err.status === 401) {
          this.spinnerService.hide();
          this.unauthorizedException();
        }
      }
    );
  }
  getBackgroundColor(id):string{
    if(id==161){
      return "#963bf1";
    }
    else if(id==160){
      return "#009EFB";
    }
    else if(id==170){
      return "#04B440";
    }
    else{
      return "red";
    }
  }
 getUserType(usertype:number):string{
  if(usertype==0){
    return"";
  }
  if(usertype==160){
     return "User";
  }
  else if(usertype==161){
     return "Admin"
  }
  else if(usertype==170){
    return "Help Desk"
  }
  else{
  let s=this.roleTypes.filter((value,key)=>{
    if(value.id==usertype){
    return value.role;
    }
    
    
  });
 
  console.log(s[0]);
//  let element=this.roleList.map((value,key)=>value.roleTypes);
//  element=element.filter((value,key)=>value.roleId==usertype);
//  console.log(element);
// if(s[0].role=='Regular'){
// this.color="green";
// }
// else if(s[0].role=='Most Privileged'){
// this.color="orange";
// }
// else{
// this.color="red";
// }
 return s[0].role;
}
 }
  onSelectChange(event: any): void {
    // Handle the change event here
    console.log('Selected value:', this.selectedType);
    console.log('page',this.pageNo,'pagesize',this.PageSize,'search',this.searchKey,'type',this.selectedType);
    this.pageNo=0;
    this.paginator.pageIndex=0;
    this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
    // You can perform additional actions or logic based on the selected value
  }
  resetFilter(){
    this.searchKey='';
    this.selectedType=0;
    this.selectedSubCategory=0;
    this.selectedCategory=0;
    this.isPresent=false;
    this.pageNo=0;
    this.selectedAssigner= 'Select Status';
    // this.selectedAssigners='Select Status';
    this.paginator.pageIndex=0;
    this.getHelpdesk(1,10,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
  }
  filterEvent(event: Event): void {
    // Check if the event is a KeyboardEvent and the key is 'Enter'
    if ((event as KeyboardEvent).key === 'Enter') {
      this.applyFilter(); // Call your filter function
      return; // Exit to prevent further execution
    }
    const filterValue = (event.target as HTMLInputElement).value.trim();
    console.log(filterValue.length);
    if(filterValue.length==0){
      this.paginator.pageIndex=0;
      this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
    }
    
  }
  applyFilter() {
    console.log(this.searchKey.trim());
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.paginator.pageIndex=0;
    this.getHelpdesk(1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
  }
  onPaginatorClick(event: any): void {
    console.log('Paginator click event:', event);
    console.log('Paginator click event:', event);
    this.PageSize=event.pageSize;
    this.pageNo=event.pageIndex
    this.cdr.detectChanges();
    this.getHelpdesk(this.pageNo+1,this.PageSize,this.searchKey,this.selectedType,this.selectedCategory,this.selectedSubCategory);
  }

  unauthorizedException() {
    Swal.fire({
      icon: "warning",
      title: "Session Expired!",
      allowOutsideClick: false,
      confirmButtonColor: "#d33",
      confirmButtonText: "Logout"
    }).then(() => {
      localStorage.clear();
      this.router.navigate(["/login"]);

    });
    return;
  }
}
